import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

const _66f5f20a = () => interopDefault(import('../pages/monitoring.vue'
/* webpackChunkName: "pages/monitoring" */
));

const _03f207ce = () => interopDefault(import('../pages/redirect_url.vue'
/* webpackChunkName: "pages/redirect_url" */
));

const _9c8cb088 = () => interopDefault(import('../pages/tools/grid.vue'
/* webpackChunkName: "pages/tools/grid" */
));

const _6e1a9974 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "pages/_market/_language/index" */
));

const _bb55c524 = () => interopDefault(import('../pages/_market/_language/cart.vue'
/* webpackChunkName: "pages/_market/_language/cart" */
));

const _53a9b852 = () => interopDefault(import('../pages/_market/_language/help/index.vue'
/* webpackChunkName: "pages/_market/_language/help/index" */
));

const _37c23c8b = () => interopDefault(import('../pages/_market/_language/login.vue'
/* webpackChunkName: "pages/_market/_language/login" */
));

const _364f8cc6 = () => interopDefault(import('../pages/_market/_language/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/lost-password" */
));

const _621cdba7 = () => interopDefault(import('../pages/_market/_language/reset-password.vue'
/* webpackChunkName: "pages/_market/_language/reset-password" */
));

const _0cdf41e6 = () => interopDefault(import('../pages/_market/_language/signup.vue'
/* webpackChunkName: "pages/_market/_language/signup" */
));

const _7612c29a = () => interopDefault(import('../pages/_market/_language/sitemap/index.vue'
/* webpackChunkName: "pages/_market/_language/sitemap/index" */
));

const _92110062 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "pages/_market/_language/store-locator/index" */
));

const _69f59f48 = () => interopDefault(import('../pages/_market/_language/user/index.vue'
/* webpackChunkName: "pages/_market/_language/user/index" */
));

const _1384f540 = () => interopDefault(import('../pages/_market/_language/help/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/confirm" */
));

const _94d44ea8 = () => interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
/* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
));

const _52340a3d = () => interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
/* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
));

const _8c0d146c = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "pages/_market/_language/s/home-by-me" */
));

const _084bb2f6 = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "pages/_market/_language/s/lighting" */
));

const _3d455cf1 = () => interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
/* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
));

const _62c4dfa6 = () => interopDefault(import('../pages/_market/_language/t/confirmed.vue'
/* webpackChunkName: "pages/_market/_language/t/confirmed" */
));

const _2b5d6630 = () => interopDefault(import('../pages/_market/_language/t/login.vue'
/* webpackChunkName: "pages/_market/_language/t/login" */
));

const _36657d2a = () => interopDefault(import('../pages/_market/_language/t/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/t/lost-password" */
));

const _5e61a28d = () => interopDefault(import('../pages/_market/_language/t/payment.vue'
/* webpackChunkName: "pages/_market/_language/t/payment" */
));

const _44833ff3 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-canceled.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-canceled" */
));

const _edca29a6 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
));

const _6ba01e57 = () => interopDefault(import('../pages/_market/_language/t/refused.vue'
/* webpackChunkName: "pages/_market/_language/t/refused" */
));

const _7651f637 = () => interopDefault(import('../pages/_market/_language/t/shipping.vue'
/* webpackChunkName: "pages/_market/_language/t/shipping" */
));

const _e6ad663e = () => interopDefault(import('../pages/_market/_language/t/signup.vue'
/* webpackChunkName: "pages/_market/_language/t/signup" */
));

const _3367996c = () => interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-cards" */
));

const _37556d8e = () => interopDefault(import('../pages/_market/_language/user/orders/index.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/index" */
));

const _17f29933 = () => interopDefault(import('../pages/_market/_language/user/profile.vue'
/* webpackChunkName: "pages/_market/_language/user/profile" */
));

const _11862d76 = () => interopDefault(import('../pages/_market/_language/user/profile/index.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/index" */
));

const _4b513246 = () => interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
));

const _68d58823 = () => interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
));

const _5e683127 = () => interopDefault(import('../pages/_market/_language/user/profile/password.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/password" */
));

const _e3225aaa = () => interopDefault(import('../pages/_market/_language/user/wishlist.vue'
/* webpackChunkName: "pages/_market/_language/user/wishlist" */
));

const _3461c6ae = () => interopDefault(import('../pages/_market/_language/help/merchant/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/confirm" */
));

const _41eebcf4 = () => interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
));

const _bd38a5f2 = () => interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
));

const _498f4518 = () => interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/contact/_form" */
));

const _a4369138 = () => interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
/* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
));

const _f9b4ac98 = () => interopDefault(import('../pages/_market/_language/help/return/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/return/_form" */
));

const _770631c0 = () => interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
));

const _75d645c9 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/index.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/index" */
));

const _2c596a96 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/messages.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/messages" */
));

const _867f0b68 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/notation.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/notation" */
));

const _0c1ecaba = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/product/_code.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/product/_code" */
));

const _77a0f6c3 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/_code.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/_code" */
));

const _2eed154b = () => interopDefault(import('../pages/_market/_language/c/_alias.vue'
/* webpackChunkName: "pages/_market/_language/c/_alias" */
));

const _5c1ec734 = () => interopDefault(import('../pages/_market/_language/configurator/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/_model" */
));

const _18c44adc = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
));

const _7bdd8b01 = () => interopDefault(import('../pages/_market/_language/m/_alias.vue'
/* webpackChunkName: "pages/_market/_language/m/_alias" */
));

const _da1b09c4 = () => interopDefault(import('../pages/_market/_language/p/_alias.vue'
/* webpackChunkName: "pages/_market/_language/p/_alias" */
));

const _75fea256 = () => interopDefault(import('../pages/_market/_language/q/_keyword.vue'
/* webpackChunkName: "pages/_market/_language/q/_keyword" */
));

const _f2934af8 = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
));

const _d3e9a946 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "" */
));

const _63bd6b49 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "" */
));

const _52a6eaad = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "" */
));

const _4b34c87e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "" */
));

const _3cb0debb = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "" */
));

const _4aca05f8 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "" */
));

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual';
    });
  }
}

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(r => r.components.default.options.scrollToTop !== false)) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _66f5f20a,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _03f207ce,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _9c8cb088,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _6e1a9974,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _bb55c524,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _53a9b852,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _37c23c8b,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _364f8cc6,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _621cdba7,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _0cdf41e6,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _7612c29a,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _92110062,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _69f59f48,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _1384f540,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _94d44ea8,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _52340a3d,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _8c0d146c,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _084bb2f6,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _3d455cf1,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _62c4dfa6,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/login",
      component: _2b5d6630,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _36657d2a,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _5e61a28d,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-canceled",
      component: _44833ff3,
      name: "market-language-t-payment-paypal-canceled"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _edca29a6,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _6ba01e57,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/shipping",
      component: _7651f637,
      name: "market-language-t-shipping"
    }, {
      path: "/:market/:language/t/signup",
      component: _e6ad663e,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _3367996c,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _37556d8e,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _17f29933,
      children: [{
        path: "",
        component: _11862d76,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _4b513246,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _68d58823,
        name: "market-language-user-profile-alerts"
      }, {
        path: "password",
        component: _5e683127,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _e3225aaa,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/help/merchant/confirm",
      component: _3461c6ae,
      name: "market-language-help-merchant-confirm"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _41eebcf4,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _bd38a5f2,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _498f4518,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _a4369138,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _f9b4ac98,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _770631c0,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact",
      component: _75d645c9,
      name: "market-language-help-merchant-order-reference-contact"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/messages",
      component: _2c596a96,
      name: "market-language-help-merchant-order-reference-messages"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/notation",
      component: _867f0b68,
      name: "market-language-help-merchant-order-reference-notation"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact/product/:code?",
      component: _0c1ecaba,
      name: "market-language-help-merchant-order-reference-contact-product-code"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact/:code?",
      component: _77a0f6c3,
      name: "market-language-help-merchant-order-reference-contact-code"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _2eed154b,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _5c1ec734,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _18c44adc,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/m/:alias?",
      component: _7bdd8b01,
      name: "market-language-m-alias"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _da1b09c4,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _75fea256,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _f2934af8,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}